import React, { ReactElement, FunctionComponent, useEffect } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import Body from '../../Theme/Fonts/Body'
import Image from '../../BaseComponents/Image'
import Caption from '../../Theme/Fonts/Caption'
import { TestID } from '../../utils/PropTypesDefinitions'
import { logComponentDeprecation } from '../../utils/Deprecation'

export type ArticleInfoProps = {
    tag: string
    published?: string
    readTime: string
    imageUrl: string
    isFavorite: boolean
    onFavorite: () => void
} & TestID

const ArticleInfo: FunctionComponent<ArticleInfoProps> = ({
    tag,
    published,
    readTime,
    imageUrl,
    isFavorite,
    onFavorite,
    testID,
}): ReactElement => {
    /* istanbul ignore next */
    useEffect(() => {
        logComponentDeprecation('ArticleInfo')
    }, [])

    return (
        <Grid horizontal centerVertical noExpand backgroundColor="pearl" testID={testID}>
            <Image imageUrl={imageUrl} aspectRatio="1:1" width={24} size="S" radiusType="circled" />
            <Grid marginLeft={3}>
                <Grid noExpand horizontal>
                    <Body color="onyx" bold textAlign="left">
                        {tag}
                    </Body>
                </Grid>
                <Grid noExpand horizontal centerVertical>
                    {published ? (
                        <>
                            <Caption color="keshi-3" textAlign="left">
                                {published}
                            </Caption>
                            <Grid
                                noExpand
                                width={2}
                                height={2}
                                borderRadius={1}
                                marginX={2}
                                backgroundColor="keshi-3"
                            />
                        </>
                    ) : null}
                    <Caption color="keshi-3" textAlign="left">
                        {readTime}
                    </Caption>
                </Grid>
            </Grid>
            <Touchable onPress={onFavorite}>
                <FontelloIcon
                    name={isFavorite ? 'favorite-active' : 'favorite'}
                    fontSize={17}
                    color={isFavorite ? 'ORANGE' : 'keshi-3'}
                />
            </Touchable>
        </Grid>
    )
}

export default ArticleInfo
